import { QSingle } from '@educraft/base';
import { IExercise, ExerciseData, addResultSimple } from '../exercise';
import { PdfUnit, PdfRect, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { GUtil } from '../../pdf/gutil';
import { makeCombinedSingle, generateUnique } from './exeUtil';

export class ExerciseEqLarge implements IExercise {
  readonly name = 'ExerciseEqLarge';
  readonly fixedHeight = 0;
  readonly noWindow = false;
  readonly injectEq = true;
  readonly injectAbc = false;

  private height = PdfUnit.FromMillimeters(50);
  private lineHeight = PdfUnit.FromMillimeters(8);
  private resultHeight = PdfUnit.FromMillimeters(10);

  draw(data: ExerciseData): void {
    if (data.item.selEq.length === 0) return;

    const gen = makeCombinedSingle(data);
    const count = Math.max(1, Math.floor(data.rect.height / this.height));
    const sizeH = data.rect.height / count;

    const array = generateUnique(gen, data.data, count, (q) => `${q.texts[0]}|${q.answer}`);

    for (let i = 0; i < count; i++) {
      const item = array[i];
      addResultSimple(data, item.answer);

      const r = new PdfRect(data.rect.x, data.rect.y + i * sizeH, data.rect.width, sizeH);

      // Draw question text lines
      for (let y = 0; y < item.texts.length; y++) {
        const r1 = new PdfRect(r.x, r.y + y * this.lineHeight, r.width, this.lineHeight);
        data.page.drawString(
          item.texts[y],
          GUtil.exerciseFont,
          PdfBrush.Black,
          null,
          r1,
          ETextAlign.CenterLeft
        );
      }

      // Draw "Vysledek:" label + result area
      const rr1 = new PdfRect(r.x, r.bottom - this.resultHeight, r.width / 2, this.resultHeight);
      const rr2 = new PdfRect(rr1.right, rr1.y, rr1.width, rr1.height);

      data.page.drawString(
        data.data.lang['Exe_Result'] ?? 'Výsledek:',
        GUtil.exerciseFont,
        PdfBrush.Black,
        null,
        rr1,
        ETextAlign.CenterRight
      );
      data.colorSchema.drawResult(data.page, rr2);
    }
  }
}
